import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ title, text, link }) => {
  return (
    <div className="col-md-4 mb-4 d-flex align-items-stretch">
      <div className="card shadow-sm w-100">
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">{title}</h5>
          <p className="card-text flex-grow-1">{text}</p>
          <Link to={link} className="btn btn-primary mt-auto">View</Link>
        </div>
      </div>
    </div>
  );
};

export default Card;